module.exports = __webpack_public_path__ + "static/media/lo5.d77a94a2.png";